/* =====================================================================
   Dibu! · Tabla de variantes — motor v2.1
   Archivo: assets/product-variants-table-v2.js
   =====================================================================
 
   CAMBIOS DE LA v2.1 (correcciones sobre la primera instalación)
 
   A. "Sin stock disponible" falso al agregar varias filas rápido.
      Era una carrera: cuando volvía la respuesta de la PRIMERA escritura,
      sincronizar() repintaba TODAS las filas con lo que decía el carrito
      en ese instante — incluidas las que el cliente acababa de pinchar y
      cuya escritura todavía estaba en la cola. Esas filas volvían a 0 y,
      como su cantidad pedida (1) era mayor que la del servidor (0), se
      disparaba el aviso de falta de stock. Ahora sincronizar() deja
      intactas las filas con escritura pendiente, y solo evalúa recortes
      para los ids que iban en ESA escritura.
 
   B. El botón ya no "piensa". La pintura optimista es instantánea y no se
      bloquea nada: se puede seguir pinchando durante la escritura, porque
      la cola fusiona. El indicador de espera aparece solo si la respuesta
      tarda más de 600 ms, es un punto pequeño al costado y no tapa ni
      apaga el control.
 
   C. Lupa en dos tiempos. Al pasar el mouse (solo escritorio) se muestra
      una vista ampliada flotante; al hacer clic se abre centrada. La capa
      abre AL INSTANTE con la imagen media, que ya está en caché, y cambia
      a resolución completa en cuanto llega. Nunca hay un segundo en
      blanco.
 
   D. Precarga por cercanía. Las miniaturas de las primeras filas vienen
      en el HTML; el resto entra por lazy nativo. La imagen media de cada
      fila se calienta cuando la fila se acerca a la pantalla (600 px
      antes), de a 6 en paralelo y arrancando después de load. Así el
      clic siempre encuentra la imagen lista sin descargar 95 fotos de
      golpe.
 
   E. Ancla #variants-table. El botón "VER OPCIONES DEL PRODUCTO" vuelve a
      funcionar, y ahora se desplaza suave en vez de saltar.
   ===================================================================== */
 
(function () {
  'use strict';
 
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
 
  var ESPERA_ESCRITURA = 220;   // ms de fusión antes de mandar al carrito
  var ESPERA_CAJON     = 700;   // ms antes de refrescar el cajón
  var ESPERA_SPINNER   = 600;   // ms antes de mostrar que estamos esperando
  var VENTANA_PROPIA   = 1500;  // ms en que ignoramos los eventos que causamos
  var PRECARGA_A_LA_VEZ = 6;    // imágenes medias en paralelo
  var MARGEN_PRECARGA = '600px 0px';
 
  var deseado    = new Map();   // id -> cantidad pedida, aún NO escrita
  var ultimoPide = new Map();   // id -> cantidad de la escritura en curso
  var enVuelo    = false;
  var timerEscritura = null;
  var timerCajon     = null;
  var timerSpinner   = null;
  var ultimaEscritura = 0;
 
  /* ================= utilidades ================= */
 
  function filas(id) {
    return document.querySelectorAll('[data-vt-row][data-variant-id="' + id + '"]');
  }
  function todas() {
    return document.querySelectorAll('[data-vt-row]');
  }
  function tope(fila) {
    var raw = fila.getAttribute('data-max');
    if (raw === null || raw === '') return Infinity;
    var n = parseInt(raw, 10);
    return isNaN(n) ? Infinity : n;
  }
  function cantidad(fila) {
    var n = parseInt(fila.getAttribute('data-qty') || '0', 10);
    return isNaN(n) ? 0 : n;
  }
  function escritorio() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
           window.innerWidth >= 750;
  }
 
  /* ================= pintado ================= */
 
  function pintarFila(fila, n) {
    var max = tope(fila);
 
    fila.setAttribute('data-qty', n);
    fila.classList.toggle('is-picked', n > 0);
 
    var add   = fila.querySelector('[data-vt-add]');
    var sel   = fila.querySelector('.input-selector');
    var input = fila.querySelector('[data-vt-qty]');
    var menos = fila.querySelector('[data-vt-minus]');
    var mas   = fila.querySelector('[data-vt-plus]');
 
    if (add) add.hidden = n > 0;
    if (sel) sel.hidden = n === 0;
 
    // No pisamos lo que el cliente está escribiendo en ese momento.
    if (input && document.activeElement !== input) input.value = String(n);
 
    if (menos) menos.disabled = n <= 0;
    if (mas)   mas.disabled   = n >= max;
  }
 
  function pintar(id, n) {
    var lista = filas(id);
    for (var i = 0; i < lista.length; i++) pintarFila(lista[i], n);
  }
 
  function ocupada(id, si) {
    var lista = filas(id);
    for (var i = 0; i < lista.length; i++) lista[i].classList.toggle('is-busy', si);
  }
 
  function avisar(id, texto) {
    var lista = filas(id);
    for (var i = 0; i < lista.length; i++) {
      var msg = lista[i].querySelector('[data-vt-msg]');
      if (msg) msg.textContent = texto || '';
    }
    if (texto) {
      setTimeout(function () {
        var l = filas(id);
        for (var k = 0; k < l.length; k++) {
          var m = l[k].querySelector('[data-vt-msg]');
          if (m && m.textContent === texto) m.textContent = '';
        }
      }, 4000);
    }
  }
 
  function parpadear(id) {
    var lista = filas(id);
    for (var i = 0; i < lista.length; i++) {
      var input = lista[i].querySelector('[data-vt-qty]');
      if (!input) continue;
      input.classList.add('vt-flash');
      (function (el) {
        setTimeout(function () { el.classList.remove('vt-flash'); }, 470);
      })(input);
    }
  }
 
  /* ================= lectura del carrito ================= */
 
  function mapaDeCarrito(cart) {
    var mapa = new Map();
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var id = String(it.variant_id != null ? it.variant_id : it.id);
      mapa.set(id, (mapa.get(id) || 0) + (it.quantity || 0));
    }
    return mapa;
  }
 
  /* Repinta la tabla desde la verdad del servidor.
     `idsEscritos` son los ids que iban en la escritura recién completada:
     solo para ellos se evalúa si Shopify recortó la cantidad. Las filas con
     una petición todavía en la cola NO se tocan: su estado optimista es más
     nuevo que la respuesta que acaba de llegar. */
  function sincronizar(cart, idsEscritos) {
    var mapa = mapaDeCarrito(cart);
    var lista = todas();
 
    for (var i = 0; i < lista.length; i++) {
      var fila = lista[i];
      var id = fila.getAttribute('data-variant-id');
      if (deseado.has(id)) continue;          // hay algo pendiente: no pisar
      pintarFila(fila, mapa.get(id) || 0);
    }
 
    if (idsEscritos) {
      for (var k = 0; k < idsEscritos.length; k++) {
        var vid = idsEscritos[k];
        if (deseado.has(vid)) { ultimoPide.delete(vid); continue; }
        var pedido = ultimoPide.get(vid);
        ultimoPide.delete(vid);
        if (pedido == null) continue;
        var real = mapa.get(vid) || 0;
        if (real < pedido) {
          avisar(vid, real === 0 ? 'Sin stock disponible.' : 'Solo quedan ' + real + '.');
          parpadear(vid);
        }
      }
    }
 
    pintarFab(cart);
 
    document.dispatchEvent(
      new CustomEvent('dibu:vtable:sync', { detail: { cart: cart } })
    );
  }
 
  function leerCarrito() {
    return fetch(ROOT + 'cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (res) {
      if (!res.ok) throw new Error('cart.js ' + res.status);
      return res.json();
    });
  }
 
  /* ================= escritura ================= */
 
  function programarEscritura() {
    clearTimeout(timerEscritura);
    timerEscritura = setTimeout(escribir, ESPERA_ESCRITURA);
  }
 
  function escribir() {
    if (enVuelo) { programarEscritura(); return; }
    if (deseado.size === 0) return;
 
    enVuelo = true;
    ultimaEscritura = Date.now();
 
    var updates = {};
    var ids = [];
    deseado.forEach(function (q, id) { updates[id] = q; ids.push(id); });
    deseado.clear();
 
    // El indicador de espera solo aparece si la red se demora de verdad.
    clearTimeout(timerSpinner);
    timerSpinner = setTimeout(function () {
      ids.forEach(function (id) { if (!deseado.has(id)) ocupada(id, true); });
    }, ESPERA_SPINNER);
 
    fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('update.js ' + res.status);
        return res.json();
      })
      .then(function (cart) {
        sincronizar(cart, ids);
        ultimaEscritura = Date.now();
        programarRefrescoCajon();
      })
      .catch(function (e) {
        leerCarrito().then(function (c) { sincronizar(c); }).catch(function () {});
        ids.forEach(function (id) { avisar(id, 'No se pudo actualizar. Intenta de nuevo.'); });
        if (window.console) console.error('[vtable]', e);
      })
      .then(function () {
        clearTimeout(timerSpinner);
        ids.forEach(function (id) { ocupada(id, false); });
        enVuelo = false;
        if (deseado.size) programarEscritura();
      });
  }
 
  /* Pide una cantidad ABSOLUTA: pinta al instante y encola. */
  function pedir(id, n) {
    var lista = filas(id);
    if (!lista.length) return;
    var max = tope(lista[0]);
    var q = Math.max(0, max === Infinity ? n : Math.min(n, max));
 
    if (n > q) { avisar(id, 'Máximo ' + q + ' por el stock disponible.'); parpadear(id); }
 
    pintar(id, q);
    deseado.set(id, q);
    ultimoPide.set(id, q);
    ocupada(id, false);          // si venía marcada por una escritura previa
    programarEscritura();
  }
 
  /* ================= cajón de carrito ================= */
 
  function programarRefrescoCajon() {
    clearTimeout(timerCajon);
    timerCajon = setTimeout(refrescarCajon, ESPERA_CAJON);
  }
 
  function refrescarCajon() {
    fetch(ROOT + '?sections=cart-drawer', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        if (!data || !data['cart-drawer']) return;
        var doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
 
        var nuevo  = doc.querySelector('cart-drawer');
        var actual = document.querySelector('cart-drawer');
        if (nuevo && actual) actual.innerHTML = nuevo.innerHTML;
 
        var contador = doc.querySelector('#cart_bubble_counter');
        var burbuja  = document.querySelector('.header__cart-count-number');
        if (contador && burbuja) burbuja.innerHTML = contador.value;
 
        ultimaEscritura = Date.now();
      })
      .catch(function (e) { if (window.console) console.error('[vtable] cajón', e); });
  }
 
  /* ================= carrito flotante ================= */
 
  /* Aparece cuando hay algo en el carro y el cliente ya entró en la tabla.
     Al tocarlo se abre el cajón de carrito del tema: para eso pulsamos el
     mismo enlace del carrito que usaría el cliente en el header, así
     heredamos lo que el tema ya hace (abrir cajón, animación, foco). Si no
     encontramos ninguno, vamos a la página del carro, que nunca falla. */
 
  var SELECTORES_CARRITO = [
    '[data-js-cart-drawer-open]',
    '[data-drawer="cart"]',
    '.js-cart-drawer-open',
    '.header__icon--cart',
    'header a[href$="/cart"]',
    'a[href$="/cart"]'
  ];
 
  var ICONO_FAB =
    '<svg class="vt-fab__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
    'stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<circle cx="9" cy="20" r="1.4" fill="currentColor" stroke="none"/>' +
    '<circle cx="19" cy="20" r="1.4" fill="currentColor" stroke="none"/>' +
    '<path d="M1.5 2h3.2l2.3 11.4a1.7 1.7 0 0 0 1.7 1.4h8.6a1.7 1.7 0 0 0 1.7-1.4L21 5.6H5.6"/></svg>';
 
  var fab = null, fabN = null, fabT = null;
  var fabUnidades = 0;
  var timerApagado = null;
 
  function tabla() { return document.querySelector('[data-vtable]'); }
 
  function visible(el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
  }
 
  function abrirCarrito() {
    for (var i = 0; i < SELECTORES_CARRITO.length; i++) {
      var el = document.querySelector(SELECTORES_CARRITO[i]);
      if (visible(el)) { el.click(); return; }
    }
    window.location.href = ROOT + 'cart';
  }
 
  /* Formato de moneda del tema, para no inventar "$13960" donde la tienda
     escribe "$13.960". El patrón viene de shop.money_format vía Liquid. */
  function agrupar(centavos, decimales, sepMiles, sepDecimal) {
    var n = (centavos / 100).toFixed(decimales);
    var partes = n.split('.');
    var entero = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, sepMiles);
    return decimales ? entero + sepDecimal + partes[1] : entero;
  }
 
  function formatearDinero(centavos, patron) {
    var f = (patron || '${{amount_no_decimals_with_comma_separator}}').replace(/<[^>]*>/g, '');
 
    /* En Chile no se escriben los centavos, y el resto del sitio tampoco los
       escribe. Si el monto no tiene centavos, omitimos la parte decimal aunque
       el formato de la tienda la pida: "$25.290", no "$25.290,00". Si algún
       día hubiera centavos de verdad, se muestran. */
    var dec = (centavos % 100 === 0) ? 0 : 2;
 
    return f.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, clave) {
      switch (clave) {
        case 'amount':                                  return agrupar(centavos, dec, ',', '.');
        case 'amount_no_decimals':                      return agrupar(centavos, 0, ',', '');
        case 'amount_with_comma_separator':             return agrupar(centavos, dec, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return agrupar(centavos, 0, '.', '');
        case 'amount_with_apostrophe_separator':        return agrupar(centavos, dec, "'", '.');
        case 'amount_no_decimals_with_space_separator': return agrupar(centavos, 0, ' ', '');
        case 'amount_with_space_separator':             return agrupar(centavos, dec, ' ', ',');
        default: return '';
      }
    }).trim();
  }
 
  function crearFab() {
    var t = tabla();
    if (!t || t.getAttribute('data-fab') === 'false') return null;
    if (fab) return fab;
 
    fab = document.createElement('button');
    fab.type = 'button';
    fab.className = 'vt-fab';
    fab.innerHTML = ICONO_FAB +
      '<span class="vt-fab__n" data-fab-n>0</span>' +
      '<span class="vt-fab__t" data-fab-t></span>';
    /* Se esconde antes de abrir el cajón, para que no se vea un parpadeo
       encima mientras el cajón entra. */
    fab.addEventListener('click', function () {
      silenciarHasta = Date.now() + 900;
      fab.classList.remove('is-on');
      var t2 = tabla();
      if (t2) t2.classList.remove('has-fab');
      abrirCarrito();
    });
    document.body.appendChild(fab);
 
    fabN = fab.querySelector('[data-fab-n]');
    fabT = fab.querySelector('[data-fab-t]');
    return fab;
  }
 
  function pintarFab(cart) {
    var t = tabla();
    if (!t || !crearFab()) return;
 
    fabUnidades = (cart && cart.item_count) || 0;
    fabN.textContent = String(fabUnidades);
 
    if (t.getAttribute('data-fab-total') !== 'false' && cart) {
      fabT.textContent = formatearDinero(cart.total_price || 0, t.getAttribute('data-money-format'));
    } else {
      fabT.textContent = '';
    }
 
    var unidades = fabUnidades === 1 ? '1 unidad' : fabUnidades + ' unidades';
    fab.setAttribute('aria-label', 'Ver el carro: ' + unidades + '. Se abre el detalle para pagar.');
    evaluarFab();
  }
 
  /* ¿Hay algo abierto por encima de la página? Un cajón de carrito, un modal,
     nuestra propia lupa. Si lo hay, la píldora se esconde: si no, se queda
     encima del botón de finalizar compra y lo tapa.
     No sé qué clase usa el tema al abrir su cajón, así que en vez de
     adivinarla busco tres señales que sirven en cualquier tema: un elemento
     que se declare modal, un <dialog> abierto, o que el scroll del body haya
     quedado bloqueado — cosa que casi todos los cajones hacen y que comparo
     contra cómo estaba la página al cargar, para no confundirlo con un tema
     que siempre lo tiene bloqueado. */
  var silenciarHasta = 0;
 
  /* Un elemento cuenta como "encima" solo si de verdad está en pantalla y
     encima de la píldora. Esto importa: casi todos los temas dejan el cajón
     de carrito siempre en el DOM, corrido fuera de la pantalla y con
     aria-modal puesto de forma permanente. Mirar solo el atributo daba el
     cajón por abierto siempre y la píldora no aparecía nunca. */
  function enPantalla(el) {
    var r = el.getBoundingClientRect();
    if (r.width < 40 || r.height < 40) return false;
    if (r.right <= 4 || r.bottom <= 4) return false;
    if (r.left >= window.innerWidth - 4 || r.top >= window.innerHeight - 4) return false;
    var cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden') return false;
    if (parseFloat(cs.opacity || '1') < 0.15) return false;
    return true;
  }
 
  /* ¿Se cruza con el rectángulo de la píldora? Si no la toca, no la tapa, y
     no hay razón para esconderla. */
  function seCruzaConFab(el) {
    if (!fab) return false;
    var a = fab.getBoundingClientRect();
    var b = el.getBoundingClientRect();
    return !(b.right <= a.left || b.left >= a.right || b.bottom <= a.top || b.top >= a.bottom);
  }
 
  /* ¿Ocupa una porción seria de la pantalla? Un cajón lateral en escritorio no
     tapa la píldora, pero igual conviene esconderla: dos carritos a la vez
     confunden. En cambio la burbuja del chat, que también puede declararse
     modal, es diminuta y no debe esconder nada. */
  function cubreBastante(el) {
    var r = el.getBoundingClientRect();
    var visto = Math.max(0, Math.min(r.right, window.innerWidth) - Math.max(r.left, 0)) *
                Math.max(0, Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0));
    return visto / (window.innerWidth * window.innerHeight) >= 0.15;
  }
 
  function hayCapaEncima() {
    if (document.body.classList.contains('vt-lb-open')) return true;
 
    var modales = document.querySelectorAll(
      '[aria-modal="true"], dialog[open], cart-drawer[open], .drawer.is-open, .js-drawer-open'
    );
    for (var i = 0; i < modales.length; i++) {
      var el = modales[i];
      if (enPantalla(el) && (seCruzaConFab(el) || cubreBastante(el))) return true;
    }
    return false;
  }
 
  /* Diagnóstico, por si algún día la píldora no aparece y hay que saber por
     qué. En la consola del navegador: dibuTabla.porQue() */
  window.dibuTabla = window.dibuTabla || {};
  window.dibuTabla.porQue = function () {
    var t = tabla();
    if (!t) return 'No hay tabla en esta página.';
    if (!fab) return 'La píldora no se creó. ¿data-fab="false" en la sección?';
    var tapan = [];
    var modales = document.querySelectorAll('[aria-modal="true"], dialog[open], cart-drawer[open]');
    for (var i = 0; i < modales.length; i++) {
      if (enPantalla(modales[i]) && seCruzaConFab(modales[i])) {
        tapan.push(modales[i].tagName + '.' + (modales[i].className || '(sin clase)'));
      }
    }
    return {
      unidadesEnElCarro: fabUnidades,
      entroEnLaTabla: t.getBoundingClientRect().top < window.innerHeight * 0.35,
      silenciadaPorClicReciente: Date.now() < silenciarHasta,
      lupaAbierta: document.body.classList.contains('vt-lb-open'),
      capasQueLaTapan: tapan,
      visibleAhora: fab.classList.contains('is-on')
    };
  };
 
  /* Se muestra una vez que el cliente entró en la tabla —antes de eso el
     carrito del header sigue a la vista y serían dos carritos compitiendo. */
  function evaluarFab() {
    if (!fab) return;
    var t = tabla();
    if (!t) return;
    var entro = t.getBoundingClientRect().top < window.innerHeight * 0.35;
    var mostrar = fabUnidades > 0 && entro &&
                  Date.now() > silenciarHasta &&
                  !hayCapaEncima();
    fab.classList.toggle('is-on', mostrar);
    t.classList.toggle('has-fab', mostrar);
  }
 
  /* El cajón puede abrirse o cerrarse sin que haya scroll de por medio, así
     que además de mirar el scroll vigilamos los cambios del documento. */
  var pendienteObs = false;
  var obsCapas = null;
 
  /* Los cajones suelen abrirse cambiando una clase o un style sobre sí mismos
     o sobre el <body>, sin mover nada más. Vigilamos el body y cada uno de sus
     hijos directos —ahí viven los cajones y los modales— en vez del documento
     entero, que dispararía con cada clic en la tabla. Al aparecer hijos
     nuevos volvemos a enganchar. */
  function engancharHijos() {
    if (!obsCapas) return;
    var hijos = document.body.children;
    for (var i = 0; i < hijos.length; i++) {
      if (hijos[i] === fab) continue;
      obsCapas.observe(hijos[i], {
        attributes: true, attributeFilter: ['class', 'style', 'open', 'aria-modal', 'aria-hidden', 'hidden']
      });
    }
  }
 
  function vigilarCapas() {
    if (!window.MutationObserver) return;
    obsCapas = new MutationObserver(function (registros) {
      for (var i = 0; i < registros.length; i++) {
        if (registros[i].type === 'childList') { engancharHijos(); break; }
      }
      if (pendienteObs) return;
      pendienteObs = true;
      requestAnimationFrame(function () { pendienteObs = false; evaluarFab(); });
    });
    obsCapas.observe(document.body, {
      attributes: true, attributeFilter: ['class', 'style'], childList: true
    });
    engancharHijos();
  }
 
  var pendienteFab = false;
  window.addEventListener('scroll', function () {
    if (fab) {
      fab.classList.add('is-dim');
      clearTimeout(timerApagado);
      timerApagado = setTimeout(function () {
        if (fab) fab.classList.remove('is-dim');
      }, 380);
    }
    if (pendienteFab) return;
    pendienteFab = true;
    requestAnimationFrame(function () { pendienteFab = false; evaluarFab(); });
  }, { passive: true });
 
  window.addEventListener('resize', evaluarFab);
 
  /* ================= eventos de compra ================= */
 
  document.addEventListener('click', function (evt) {
    var t = evt.target;
    if (!t || !t.closest) return;
 
    var boton = t.closest('[data-vt-add], [data-vt-plus], [data-vt-minus]');
    if (boton && !boton.disabled) {
      var fila = boton.closest('[data-vt-row]');
      if (!fila) return;
      evt.preventDefault();
      var id = fila.getAttribute('data-variant-id');
      var actual = cantidad(fila);
      pedir(id, boton.hasAttribute('data-vt-minus') ? actual - 1 : actual + 1);
      return;
    }
 
    var zoom = t.closest('[data-vt-zoom]');
    if (zoom) { evt.preventDefault(); ocultarPreview(); abrirLupa(zoom); }
  });
 
  document.addEventListener('change', function (evt) {
    var input = evt.target.closest && evt.target.closest('[data-vt-qty]');
    if (!input) return;
    var fila = input.closest('[data-vt-row]');
    if (!fila) return;
    var n = parseInt(input.value, 10);
    if (isNaN(n) || n < 0) n = 0;
    pedir(fila.getAttribute('data-variant-id'), n);
  });
 
  document.addEventListener('keydown', function (evt) {
    if (evt.key === 'Enter' && evt.target.matches && evt.target.matches('[data-vt-qty]')) {
      evt.preventDefault();
      evt.target.blur();
    }
  });
 
  document.addEventListener('focusin', function (evt) {
    if (evt.target.matches && evt.target.matches('[data-vt-qty]')) evt.target.select();
  });
 
  /* ================= imágenes: precarga por cercanía ================= */
 
  var cola = [];
  var enCurso = 0;
  var calentadas = new Set();
 
  function calentar(src) {
    if (!src || calentadas.has(src)) return;
    calentadas.add(src);
    cola.push(src);
    bombear();
  }
 
  function bombear() {
    while (enCurso < PRECARGA_A_LA_VEZ && cola.length) {
      var src = cola.shift();
      enCurso++;
      var img = new Image();
      img.onload = img.onerror = function () { enCurso--; bombear(); };
      img.decoding = 'async';
      img.src = src;
    }
  }
 
  function vigilarImagenes() {
    var botones = document.querySelectorAll('[data-vt-zoom]');
    if (!botones.length) return;
 
    if (!('IntersectionObserver' in window)) {
      // Sin observador calentamos solo las primeras, para no bajar 95 fotos.
      for (var i = 0; i < Math.min(botones.length, 20); i++) {
        calentar(botones[i].getAttribute('data-mid-src'));
      }
      return;
    }
 
    var obs = new IntersectionObserver(function (entradas) {
      for (var k = 0; k < entradas.length; k++) {
        if (!entradas[k].isIntersecting) continue;
        var el = entradas[k].target;
        calentar(el.getAttribute('data-mid-src'));
        obs.unobserve(el);
      }
    }, { rootMargin: MARGEN_PRECARGA });
 
    for (var j = 0; j < botones.length; j++) obs.observe(botones[j]);
  }
 
  /* Aparición suave de cada miniatura, sin saltos de layout: la celda ya
     reserva 75 × 75, así que solo cambia la opacidad. */
  function encenderMiniaturas() {
    var imgs = document.querySelectorAll('.dibu-vtable .table--img img');
    for (var i = 0; i < imgs.length; i++) {
      (function (img) {
        if (img.complete && img.naturalWidth) { img.classList.add('is-on'); return; }
        img.addEventListener('load', function () { img.classList.add('is-on'); });
        img.addEventListener('error', function () { img.classList.add('is-on'); });
      })(imgs[i]);
    }
  }
 
  /* ================= vista ampliada al pasar el mouse ================= */
 
  var preview = null;
  var previewDe = null;
 
  function crearPreview() {
    if (preview) return preview;
    preview = document.createElement('img');
    preview.className = 'vt-preview';
    preview.alt = '';
    preview.setAttribute('aria-hidden', 'true');
    document.body.appendChild(preview);
    return preview;
  }
 
  function mostrarPreview(boton) {
    if (!escritorio()) return;
    var src = boton.getAttribute('data-mid-src') || boton.getAttribute('data-zoom-src');
    if (!src) return;
 
    var p = crearPreview();
    if (previewDe !== boton) { p.src = src; previewDe = boton; }
 
    var r = boton.getBoundingClientRect();
    var lado = 240;
    var margen = 14;
 
    // A la derecha de la miniatura; si no cabe, a la izquierda.
    var izq = r.right + margen;
    if (izq + lado > window.innerWidth - 8) izq = r.left - lado - margen;
    if (izq < 8) izq = 8;
 
    var arriba = r.top + r.height / 2 - lado / 2;
    if (arriba < 8) arriba = 8;
    if (arriba + lado > window.innerHeight - 8) arriba = window.innerHeight - lado - 8;
 
    p.style.width = lado + 'px';
    p.style.height = lado + 'px';
    p.style.left = Math.round(izq) + 'px';
    p.style.top = Math.round(arriba) + 'px';
    p.classList.add('is-on');
  }
 
  function ocultarPreview() {
    if (preview) preview.classList.remove('is-on');
  }
 
  document.addEventListener('mouseover', function (evt) {
    var b = evt.target.closest && evt.target.closest('[data-vt-zoom]');
    if (b) { calentar(b.getAttribute('data-mid-src')); mostrarPreview(b); }
  });
  document.addEventListener('mouseout', function (evt) {
    var b = evt.target.closest && evt.target.closest('[data-vt-zoom]');
    if (b && !(evt.relatedTarget && b.contains(evt.relatedTarget))) ocultarPreview();
  });
  document.addEventListener('focusin', function (evt) {
    var b = evt.target.closest && evt.target.closest('[data-vt-zoom]');
    if (b) mostrarPreview(b);
  });
  document.addEventListener('focusout', function (evt) {
    if (evt.target.closest && evt.target.closest('[data-vt-zoom]')) ocultarPreview();
  });
  window.addEventListener('scroll', ocultarPreview, { passive: true });
  window.addEventListener('resize', ocultarPreview);
 
  /* ================= lupa centrada ================= */
 
  var lupa = null, focoPrevio = null, origenBoton = null;
  var DURACION_LUPA = 340;   // debe coincidir con la transición del CSS
 
  function animacionLupa() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return 'ninguna';
    var t = tabla();
    var v = t && t.getAttribute('data-zoom-anim');
    return (v === 'suave' || v === 'ninguna') ? v : 'origen';
  }
 
  /* La foto grande puede no haber decodificado todavía, y sin alto medido el
     cálculo del viaje da cualquier cosa. Esperamos, con tope, para no dejar
     la capa colgada si la imagen nunca llega. */
  function conImagenLista(img, cb) {
    if (img.complete && img.naturalWidth) { cb(); return; }
    var hecho = false;
    var seguir = function () { if (!hecho) { hecho = true; cb(); } };
    img.addEventListener('load', seguir, { once: true });
    img.addEventListener('error', seguir, { once: true });
    setTimeout(seguir, 450);
  }
 
  /* Calza la foto grande encima de la miniatura que se tocó. Devuelve false
     si la miniatura ya no está en pantalla: en ese caso el viaje no tendría
     sentido y la capa entra con el fundido simple. */
  function calzarSobreMiniatura(img, boton, animado) {
    var o = boton.getBoundingClientRect();
    var d = img.getBoundingClientRect();
    if (!o.width || !d.width || !d.height) return false;
    if (o.bottom <= 0 || o.top >= window.innerHeight) return false;
 
    var esc = Math.max(o.width / d.width, o.height / d.height);
    var dx = (o.left + o.width / 2) - (d.left + d.width / 2);
    var dy = (o.top + o.height / 2) - (d.top + d.height / 2);
    var destino = 'translate(' + dx + 'px,' + dy + 'px) scale(' + esc + ')';
 
    if (animado) {
      // Al cerrar queremos que el viaje se vea: se deja la transición puesta.
      img.style.transform = destino;
      img.style.borderRadius = '14px';
    } else {
      // Al abrir hay que posicionarla SIN animar, y recién después soltarla.
      img.style.transition = 'none';
      img.style.transform = destino;
      img.style.borderRadius = '14px';
      void img.offsetWidth;
      img.style.transition = '';
    }
    return true;
  }
 
  function abrirLupa(boton) {
    var media = boton.getAttribute('data-mid-src');
    var full  = boton.getAttribute('data-zoom-src') || media;
    if (!media && !full) return;
    var cap = boton.getAttribute('data-zoom-cap') || '';
 
    focoPrevio = document.activeElement;
    origenBoton = boton;
    var anim = animacionLupa();
 
    lupa = document.createElement('div');
    lupa.className = 'vt-lb';
    lupa.setAttribute('data-anim', anim);
    lupa.setAttribute('role', 'dialog');
    lupa.setAttribute('aria-modal', 'true');
    lupa.setAttribute('aria-label', cap ? 'Foto ampliada de ' + cap : 'Foto ampliada');
 
    var box = document.createElement('div');
    box.className = 'vt-lb__box';
 
    var img = document.createElement('img');
    img.className = 'vt-lb__img';
    img.alt = cap;
    // Abrimos con la media, que ya está en caché: la capa aparece llena.
    img.src = media || full;
    box.appendChild(img);
 
    if (cap) {
      var pie = document.createElement('div');
      pie.className = 'vt-lb__cap';
      pie.textContent = cap;
      box.appendChild(pie);
    }
 
    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'vt-lb__x';
    x.setAttribute('aria-label', 'Cerrar');
    x.textContent = '×';
    box.appendChild(x);
 
    lupa.appendChild(box);
    document.body.appendChild(lupa);
    document.body.classList.add('vt-lb-open');
    x.focus();
 
    /* Dos cuadros de espera: el primero deja que el navegador calcule la
       posición final, el segundo dispara la transición. Sin eso el navegador
       fusiona ambos estados y no se anima nada. */
    var arrancar = function () {
      if (anim === "origen") calzarSobreMiniatura(img, boton, false);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (!lupa) return;
          lupa.classList.add('is-on');
          if (anim === 'origen') { img.style.transform = ''; img.style.borderRadius = ''; }
        });
      });
    };
    if (anim === 'origen') conImagenLista(img, arrancar); else arrancar();
 
    // Y cambiamos a resolución completa en cuanto termine de bajar.
    if (full && full !== img.src) {
      var alta = new Image();
      alta.onload = function () { if (lupa && img.isConnected) img.src = full; };
      alta.src = full;
    }
 
    lupa.addEventListener('click', function (ev) {
      if (ev.target === lupa || ev.target.closest('.vt-lb__x')) cerrarLupa();
    });
  }
 
  /* Al cerrar se juega la animación al revés: la foto vuelve a su miniatura.
     La capa se quita después, no antes, o el viaje no se vería. */
  function cerrarLupa() {
    if (!lupa) return;
    var capa = lupa, anim = capa.getAttribute('data-anim');
    lupa = null;
    document.body.classList.remove('vt-lb-open');
 
    var terminar = function () {
      capa.remove();
      if (focoPrevio && focoPrevio.focus) focoPrevio.focus();
      focoPrevio = null; origenBoton = null;
    };
 
    if (anim === 'ninguna') { terminar(); return; }
 
    if (anim === 'origen' && origenBoton) {
      var img = capa.querySelector('.vt-lb__img');
      if (img) calzarSobreMiniatura(img, origenBoton, true);
    }
    capa.classList.remove('is-on');
    setTimeout(terminar, DURACION_LUPA);
  }
 
  document.addEventListener('keydown', function (evt) {
    if (evt.key === 'Escape' && lupa) cerrarLupa();
  });
 
  /* ================= ancla "VER OPCIONES DEL PRODUCTO" ================= */
 
  document.addEventListener('click', function (evt) {
    var a = evt.target.closest && evt.target.closest('a[href$="#variants-table"]');
    if (!a) return;
    var destino = document.getElementById('variants-table');
    if (!destino) return;
    evt.preventDefault();
    var suave = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    destino.scrollIntoView({ behavior: suave ? 'smooth' : 'auto', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', '#variants-table');
  });
 
  /* ================= arranque ================= */
 
  function iniciar() {
    var tabla = document.querySelector('[data-vtable]');
    if (!tabla) return;
    tabla.classList.add('js-ready');
 
    vigilarCapas();
    encenderMiniaturas();
    leerCarrito().then(function (c) { sincronizar(c); }).catch(function (e) {
      if (window.console) console.error('[vtable] inicio', e);
    });
 
    // La precarga arranca cuando la página ya terminó de cargar, para no
    // competir con la foto principal del producto ni con el tema.
    var arrancarPrecarga = function () {
      if (window.requestIdleCallback) requestIdleCallback(vigilarImagenes, { timeout: 1200 });
      else setTimeout(vigilarImagenes, 400);
    };
    if (document.readyState === 'complete') arrancarPrecarga();
    else window.addEventListener('load', arrancarPrecarga, { once: true });
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
 
  document.addEventListener('on:cart:change', function () {
    if (Date.now() - ultimaEscritura < VENTANA_PROPIA) return;
    if (!document.querySelector('[data-vtable]')) return;
    leerCarrito().then(function (c) { sincronizar(c); }).catch(function () {});
  });
})();